module.exports = __webpack_public_path__ + "img/football-category-icon-red.b77bd433.png";